import { REGISTRATION_URL_DESKTOP, REGISTRATION_URL_MOBILE } from '../constants';

export const getRegistrationUrl = () => {
  if (/iphone|ipad|ipod|android/i.test(navigator.userAgent)) {
    return REGISTRATION_URL_MOBILE;
  }

  return REGISTRATION_URL_DESKTOP;
}
